import { useIntl } from 'react-intl';

export const useLiveEvents = () => {
    const intl = useIntl();
    const itemsStr = intl.formatMessage({ id: 'eventPlannedAgendaItems', defaultMessage: '[]' });
    let items = [];
    try {
        items = JSON.parse(itemsStr);
    } catch (e) {
        console.error("Failed to parse agenda items", e);
    }

    const currentLiveEvent = items.find(item => {
        if (!item.outlookLink) return false;
        const startMatch = item.outlookLink.match(/startdt=([^&]+)/);
        const endMatch = item.outlookLink.match(/enddt=([^&]+)/);
        if (startMatch && endMatch) {
            const start = new Date(startMatch[1]);
            const end = new Date(endMatch[1]);
            const now = new Date();
            // Optional: you might want to add a buffer or just exact match
            return now >= start && now <= end;
        }
        return false;
    });

    // Manual override to forcefully disable all live indicators
    const FORCE_OFF = true;

    const isLive = FORCE_OFF ? false : !!currentLiveEvent;

    return { items, isLive, currentLiveEvent: FORCE_OFF ? null : currentLiveEvent };
};
